<template>
  <div class="num-wrap">
    <div @click="jump1()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px; ;
        "
        src="@/assets/teamGroup/cl_icon.png"
        alt=""
      />
      <div class="name">车辆管理</div>
      <div class="number">{{ carListCount }}</div>
    </div>
    <div @click="jump2()" type="primary" class="grid-item">
      <img
        style="
          float: right;
          width: 32px;
          height: 32px;
          margin-top: 8px;
          margin-right: 20px;
        "
        src="@/assets/teamGroup/jly_icon.png"
        alt=""
      />
      <div class="name">记录仪</div>
      <div class="number">{{ workCameraCount }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.num-wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 创建三个等宽的列 */
  gap: 10px; /* 可选，设置网格项之间的间隙 */
  justify-items: center;
  .grid-item {
    width: 70%;
    height: 150px;
    // display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    margin-top: 50px;
    background-color: #eff6ff;
    cursor: pointer;
    border-radius: 8px;
    .name {
      font-weight: 400;
      font-size: 20px;
      color: #526e9c;
      line-height: 16px;
      height: 16px;
      margin-left: 20px;
      margin-top: 16px;
    }
    .number {
      font-weight: 600;
      font-size: 30px;
      color: #333333;
      line-height: 24px;
      height: 24px;
      margin-left: 30px;
      margin-top: 58px;
    }
  }
}
</style>

<script>
import { carListPage, queryCameraPage } from "@/api/equipmentmanagement";

export default {
  data() {
    return {
      carListCount: 0,
      workCameraCount: 0,
    };
  },
  methods: {
    jump1() {
      this.$router.push("/carmanagement");
    },
    jump2() {
      this.$router.push("/workcamera");
    },
    async getCarListPageCount() {
      let req = {
        carId: 0,
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };
      const res = await carListPage(req);
      this.carListCount = res.data.data.total;
    },
    async queryCameraPageCount() {
      let req = {
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };
      const res = await queryCameraPage(req);
      this.workCameraCount = res.data.data.total;
    },
  },
  created() {
    this.getCarListPageCount();
    this.queryCameraPageCount();
  },
};
</script>
